import React from "react";
import RecoverView from "./RecoverView";

const RecoverModule = () => {
  return <RecoverView />;
};

export default RecoverModule;
